export default __webpack_public_path__ + "static/media/cont5.04533b16.png";